import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const ITEMS = [
  {
    quote: "I sketched our extension on a pub napkin, snapped it, and had a costed 3D plan before the pint was finished. Our builder used the scope almost word for word.",
    name: "Marcus T.",
    role: "Homeowner · Manchester, UK",
  },
  {
    quote: "As a small developer I price jobs in three countries. Getting instant local-currency numbers has saved me days of spreadsheet work every month.",
    name: "Priya N.",
    role: "Developer · Bengaluru, India",
  },
  {
    quote: "We turned a rough restaurant fit-out idea into a real tenant-improvement budget in minutes. The per-square-foot benchmarks were spot on.",
    name: "Diego R.",
    role: "Restaurateur · Austin, USA",
  },
];

export default function Testimonials() {
  return (
    <div className="grid gap-5 md:grid-cols-3" data-testid="testimonials">
      {ITEMS.map((t, i) => (
        <motion.figure
          key={i}
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: i * 0.1 }}
          className="flex flex-col justify-between border border-border bg-secondary/10 p-6"
          data-testid={`testimonial-${i}`}
        >
          <div>
            <Quote className="h-6 w-6 text-primary" />
            <blockquote className="mt-4 text-[15px] leading-relaxed text-foreground">"{t.quote}"</blockquote>
          </div>
          <figcaption className="mt-6 border-t border-border pt-4">
            <div className="font-heading text-sm font-semibold">{t.name}</div>
            <div className="font-mono2 text-[11px] uppercase tracking-widest text-muted-foreground">{t.role}</div>
          </figcaption>
        </motion.figure>
      ))}
    </div>
  );
}
